import React, { useState, useRef } from 'react';
import LoadingScreen from 'src/components/LoadingScreen';
import { Link, useHistory } from 'react-router-dom';

import { DataTable } from 'primereact/datatable';
import { InputText } from 'primereact/inputtext';
import { Toolbar } from 'primereact/toolbar';
import { ModelOfUnity } from 'src/database';
import { useAuth } from 'src/contexts/auth';
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import { Tooltip } from 'primereact/tooltip';

import { useListUnitysController } from 'src/controllers/Unitys/ListUnitysController';
import useIntersectionObserver from 'src/components/IntersectionObserver/useIntersectionObserver';
import classNames from 'classnames';
import { PulseLoader } from 'react-spinners';
import { Dropdown } from 'primereact/dropdown';

const UnitysList: React.FC = () => {
    const { getUnityListController, handleUnityListController } = useListUnitysController();
    const { userAgencyName, createUnityPeople, listUnityPeople } = useAuth();
    const history = useHistory();

    const [globalFilter, setGlobalFilter] = useState<string | null>(null);

    if (getUnityListController.loading) {
        return <LoadingScreen />;
    }

    const unityType = [
        { label: 'Outros...', code: 0 },
        { label: 'Oficina ou Garagem', code: 1 },
    ];

    const tableHeader = (
        <div className='table-header p-grid p-d-flex p-jc-between'>
            <h5 className='p-m-0'>ÓRGÃO: {userAgencyName}</h5>
            <span className='p-input-icon-left p-search-bar'>
                <i className='pi pi-search' />
                <InputText
                    type='search'
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setGlobalFilter(e.target.value)}
                    placeholder='Buscar...'
                />
            </span>
        </div>
    );

    const actionBodyTemplate = (Unity: ModelOfUnity) => {
        return (
            <React.Fragment>
                <Tooltip target=".unity-people-btn" content="Ver pessoas da unidade" position="top" />
                <Tooltip target=".unity-people-responsavel-btn" content="Ver chefe da unidade" position="top" />
                <Tooltip target=".unity-people-editar-btn" content="Editar unidade" position="top" />
                <Tooltip target=".unity-people-excluir-btn" content="Excluir unidade" position="top" />
                <Button
                    icon='pi pi-users'
                    className='p-button-rounded p-button-text p-button-success unity-people-btn'
                    onClick={() => {
                        listUnityPeople(Unity);
                        history.push('/listUnityPeoples');
                    }}
                />
                <Button
                    icon='pi pi-user-plus'
                    className='p-button-rounded p-button-text p-button-success  unity-people-responsavel-btn'
                    onClick={() => {
                        createUnityPeople(Unity);
                        history.push('/peopleForm');
                    }}
                />
                <Button
                    icon='pi pi-pencil'
                    className='p-button-rounded p-button-text p-button-success unity-people-editar-btn'
                    onClick={() => handleUnityListController.openEditDialog(Unity)}
                />
                <Button
                    icon='pi pi-trash'
                    className='p-button-rounded p-button-text p-button-danger unity-people-excluir-btn'
                    onClick={() => handleUnityListController.openDeleteDialog(Unity)}
                />
            </React.Fragment>
        );
    };

    const editUnityDialogFooter = (
        <React.Fragment>
            <Button
                label='Cancelar'
                icon='pi pi-times'
                className='p-button-text'
                onClick={handleUnityListController.closeEditDialog}
            />
            <Button
                type='submit'
                label='Salvar'
                icon='pi pi-check'
                className='p-button-text'
                onClick={() => {
                    getUnityListController.formik.handleSubmit();
                }}
            />
        </React.Fragment>
    );

    const deleteUnityDialogFooter = (
        <React.Fragment>
            <Button
                label='Não'
                icon='pi pi-times'
                className='p-button-text'
                onClick={handleUnityListController.closeDeleteDialog}
            />
            <Button
                label='Sim'
                icon='pi pi-check'
                className='p-button-text'
                onClick={() => {
                    getUnityListController.selectedUnity &&
                        handleUnityListController.removeUnity(getUnityListController.selectedUnity);
                }}
            />
        </React.Fragment>
    );

    const leftUnityToolbar = () => {
        return (
            <Link to='/unityForm'>
                <Button label='Cadastrar unidade' icon='pi pi-plus' className='p-button-success p-mr-2' />
            </Link>
        );
    };

    const HEADER_NOME = (rowData: ModelOfUnity) => {
        return (
            <React.Fragment>
                <span className='left-header'>NOME</span>
                {rowData.NOME}
            </React.Fragment>
        );
    };

    const HEADER_EMAIL = (rowData: ModelOfUnity) => {
        return (
            <React.Fragment>
                <span className='left-header'>EMAIL</span>
                {rowData.EMAIL}
            </React.Fragment>
        );
    };

    const HEADER_TELEFONE = (rowData: ModelOfUnity) => {
        return (
            <React.Fragment>
                <span className='left-header'>TELEFONE</span>
                {rowData.TELEFONE}
            </React.Fragment>
        );
    };

    const Loader: React.FC = ({ children }) => {
        const divRef: any = useRef<HTMLDivElement | null>(null);

        const [isVisible] = useIntersectionObserver({
            elementRef: divRef,
        });

        if (isVisible && !getUnityListController.maxData && !getUnityListController.loadingRows) {
            handleUnityListController.setRows(getUnityListController.rows + 20);
        }

        return (
            <div
                ref={divRef}
                style={{
                    minHeight: '5px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}>
                {children}
            </div>
        );
    };

    return (
        <div>
            <Toast ref={getUnityListController.toast} />
            <div className='p-card p-p-4 datatable-container' style={{ height: '80vh' }}>
                <Toolbar className='p-mb-4' left={leftUnityToolbar}></Toolbar>

                <DataTable
                    header={tableHeader}
                    globalFilter={globalFilter}
                    style={{ height: '100%' }}
                    className='responsive-table p-datatable-sm'
                    dataKey='ID'
                    autoLayout
                    rowHover
                    scrollable
                    scrollHeight='150%'
                    value={getUnityListController.UnitysData}>
                    <Column field='NOME' header='UNIDADES' body={HEADER_NOME}></Column>
                    <Column field='EMAIL' header='EMAIL' body={HEADER_EMAIL}></Column>
                    <Column field='TELEFONE' header='TELEFONE' body={HEADER_TELEFONE}></Column>
                    <Column body={actionBodyTemplate} bodyStyle={{ textAlign: 'right' }}></Column>
                </DataTable>
                <Loader>
                    {!getUnityListController.maxData ? (
                        getUnityListController.loadingRows ? (
                            <PulseLoader color='#0388e5' size={8} />
                        ) : (
                            <></>
                        )
                    ) : (
                        'Lista completa'
                    )}
                </Loader>
            </div>

            <Dialog
                className='p-fluid dropdown-visible'
                style={{ width: '90%' }}
                visible={getUnityListController.editDialog}
                onHide={handleUnityListController.closeEditDialog}
                onShow={() => getUnityListController.formik.setValues(getUnityListController.selectedUnity)}
                footer={editUnityDialogFooter}
                header={`Editar unidade ${getUnityListController.selectedUnity?.NOME}`}
                modal>
                {getUnityListController.loadingEdit ? <LoadingScreen color='#0388e5' /> : <></>}
                <div className='p-grid p-fluid'>
                    <div className='p-field p-col-12'>
                        <label htmlFor='nome'>Nome</label>
                        <InputText
                            id='nome'
                            maxLength={150}
                            {...getUnityListController.formik.getFieldProps('NOME')}
                            onChange={getUnityListController.formik.handleChange('NOME')}
                        />
                        <div
                            className={classNames('p-invalid popup-fade', {
                                'popup-form-active':
                                    getUnityListController.formik.touched.NOME &&
                                    getUnityListController.formik.errors.NOME,
                                'popup-form-inactive': !(
                                    getUnityListController.formik.touched.NOME &&
                                    getUnityListController.formik.errors.NOME
                                ),
                            })}>
                            {getUnityListController.formik.errors.NOME}
                        </div>
                    </div>

                    <div className='p-field p-col-12 p-md-6'>
                        <label htmlFor='email'>Email</label>
                        <InputText
                            id='email'
                            maxLength={150}
                            placeholder='unidade@email.com.br'
                            {...getUnityListController.formik.getFieldProps('EMAIL')}
                            onChange={getUnityListController.formik.handleChange('EMAIL')}
                        />
                        <div
                            className={classNames('p-invalid popup-fade', {
                                'popup-form-active':
                                    getUnityListController.formik.touched.EMAIL &&
                                    getUnityListController.formik.errors.EMAIL,
                                'popup-form-inactive': !(
                                    getUnityListController.formik.touched.EMAIL &&
                                    getUnityListController.formik.errors.EMAIL
                                ),
                            })}>
                            {getUnityListController.formik.errors.EMAIL}
                        </div>
                    </div>

                    <div className='p-field p-col-12 p-md-3'>
                        <label htmlFor='telefone'>Telefone</label>
                        <InputText
                            id='telefone'
                            maxLength={20}
                            {...getUnityListController.formik.getFieldProps('TELEFONE')}
                            onChange={getUnityListController.formik.handleChange('TELEFONE')}
                        />
                        <div
                            className={classNames('p-invalid popup-fade', {
                                'popup-form-active':
                                    getUnityListController.formik.touched.TELEFONE &&
                                    getUnityListController.formik.errors.TELEFONE,
                                'popup-form-inactive': !(
                                    getUnityListController.formik.touched.TELEFONE &&
                                    getUnityListController.formik.errors.TELEFONE
                                ),
                            })}>
                            {getUnityListController.formik.errors.TELEFONE}
                        </div>
                    </div>

                    <div className='p-field p-col-12 p-md-3'>
                        <label htmlFor='tipounidade'>Tipo de Unidade</label>
                        <Dropdown
                            id='tipounidade'
                            inputId='tipounidade'
                            {...getUnityListController.formik.getFieldProps('TIPOUNIDADE')}
                            onChange={(e) => {
                                getUnityListController.formik.setFieldValue('TIPOUNIDADE', e.value);
                            }}
                            options={unityType}
                            optionLabel='label'
                            optionValue='code'
                        />
                        <div
                            className={classNames('p-invalid popup-fade', {
                                'popup-form-active':
                                    getUnityListController.formik.touched.TIPOUNIDADE &&
                                    getUnityListController.formik.errors.TIPOUNIDADE,
                                'popup-form-inactive': !(
                                    getUnityListController.formik.touched.TIPOUNIDADE &&
                                    getUnityListController.formik.errors.TIPOUNIDADE
                                ),
                            })}>
                            {getUnityListController.formik.errors.TIPOUNIDADE}
                        </div>
                    </div>
                </div>
            </Dialog>

            <Dialog
                style={{ width: '450px' }}
                visible={getUnityListController.deleteDialog}
                onHide={handleUnityListController.closeDeleteDialog}
                footer={deleteUnityDialogFooter}
                header='Remover unidade'
                modal>
                <div className='confirmation-content'>
                    <i className='pi pi-exclamation-triangle p-mr-3' style={{ fontSize: '2rem' }} />
                    {getUnityListController.selectedUnity && (
                        <span>
                            Você tem certeza que deseja deletar a unidade{' '}
                            <b>{getUnityListController.selectedUnity.NOME}</b>?
                        </span>
                    )}
                </div>
            </Dialog>
        </div>
    );
};

export default UnitysList;
